/**
 * List of events used by voucher-redeemer
 *
 */
export const voucherRedeemer = {
  VOUCHER_REDEEMER_SERVER_VALIDATION_ERROR: 'VoucherRedeemer.ServerValidationError',
  VOUCHER_REDEEMER_SERVER_ERROR: 'VoucherRedeemer.ServerError'
}
